export class ObjectUtils {
  static getValueOrNull(...args: any[]) {
    const res = args.filter(el => el !== undefined && el !== null)
    if (res.length === 0) {
      return null
    } else {
      return res[0]
    }
  }
}
